import { ClimatisationInfo, HeatingConnectedTo } from "shared/types/climatisation";

interface CalculateUnitClimatisationDotValuesProps {
    unitClimatisationInfo: ClimatisationInfo;
}


export const calculateUnitClimatisationDotValues = ({ unitClimatisationInfo }: CalculateUnitClimatisationDotValuesProps) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    if (!unitClimatisationInfo) {
        dotValues.transparent.count += 2;
        dotValues.transparent.labels.push("Geen toestellen ingevuld");
        dotValues.transparent.labels.push("Niet duidelijk of unit is aangesloten op gemeenschap of privatief systeem");
        return dotValues;
    }

    if (unitClimatisationInfo.climatisationDevices && unitClimatisationInfo.climatisationDevices.length > 0) {
        dotValues.green.count = unitClimatisationInfo.climatisationDevices.length;
        for (let device of unitClimatisationInfo.climatisationDevices) {
            dotValues.green.labels.push(device.deviceType + " ingevuld");
        }
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Geen toestellen ingevuld");
    }

    if (unitClimatisationInfo.connectedTo && unitClimatisationInfo.connectedTo != HeatingConnectedTo.UNKNOWN) {
        dotValues.green.count++;
        dotValues.green.labels.push("Aangesloten op " + unitClimatisationInfo.connectedTo);
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Niet duidelijk of unit is aangesloten op gemeenschap of privatief systeem");
    }

    if(unitClimatisationInfo.connectedTo == HeatingConnectedTo.PRIVATE_SYSTEM) {
        if(unitClimatisationInfo.gasMeters && unitClimatisationInfo.gasMeters.length == 0) {
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Gasmeter niet ingevuld");
        } else {
            dotValues.green.count++;
            dotValues.green.labels.push("Gasmeter ingevuld");
        }
    } 
    return dotValues;
};
